define('formkit/view/form/section/section.header.collection.view',['require','exports','module','uikit/uikit'],function(require, exports, module) {
  var UIKit = require('uikit/uikit');


  var SectionHeaderCollectionView = UIKit.CollectionView.extend({

    options: {
      form: null
    },

    childView: UIKit.ItemView,

    options: {
      form: null
    },

    childViewOptions: function() {
      return {
        form: this.form
      }
    }
   });

  module.exports = SectionHeaderCollectionView;
});

